/**
 * TadReamk Create Product Configuration
 *
 * NEW STRUCTURE: Text content moved to JSON translations
 * This file now contains only non-translatable assets and configuration
 */

import tadreamkCreateImage from "../../assets/images/products/Trademark generation.webp";
import {
  FEATURE_ICONS,
  CONTENT_ICONS,
  STATUS_ICONS,
} from "../../configs/emojis";
import { APP_CONFIG } from "../../configs/config";

// New config structure - assets and non-translatable data only
export const tadreamkCreateConfig = {
  id: "tadreamk-create",
  numericId: 2, // Legacy numeric ID
  image: tadreamkCreateImage,
  ctaUrl: APP_CONFIG.TADREAMK_CREATE_URL || "https://tc.tadreamk.com",
  icons: {
    PALETTE: FEATURE_ICONS.PALETTE,
    AI: FEATURE_ICONS.AI,
    TARGET: FEATURE_ICONS.TARGET,
    GOLD_MEDAL: CONTENT_ICONS.GOLD_MEDAL,
    CHECK: STATUS_ICONS.CHECK,
  },
};

// Legacy export for backward compatibility
// Will be used by old components that haven't been migrated yet
const tadreamkCreateData = {
  id: 2,
  image: tadreamkCreateImage,
  title: "TadReamk Create",
  abstract:
    "Intelligent trademark and logo generation platform. Create unique, memorable trademarks that fulfill your requirements and avoid infringement with existing protected trademarks through embedded clearance checks and legal‑aware guidance.",
  ctaUrl: APP_CONFIG.TADREAMK_CREATE_URL || "https://tc.tadreamk.com",
  ctaText: "Create Now",
  category: "Design & Creation",
  primaryFeatureTag: "Trademark Design",
  imageAlt: "TadReamk Create AI trademark and logo generation",
  ctaPlacement: "top",
  showOverviewHeading: false,
  description: [
    {
      icon: FEATURE_ICONS.PALETTE,
      title: "Creative at scale",
      text: "Generate hundreds of brand‑ready logo and word‑mark directions in seconds, then keep exploring without losing your thread. Our model riffs like a seasoned designer—testing typography, geometry, layout, and motion—yet it always stays anchored to your brief. Spin up variants by tone or mood, branch the most exciting ideas into new sequences, and arrive at a curated board of directions in the time it used to take to name a project file.",
    },
    {
      icon: FEATURE_ICONS.AI,
      title: "Compliance‑first originality",
      text: "Originality is intentional here—not accidental. Concepts are continuously screened against registered trademark data to avoid conflicts early, and similarity signals help you steer away from look‑alikes before you invest. Language and region‑aware rules prevent unintended meanings, while adjustable constraints keep designs distinctive yet aligned to your requirements and filing strategy.",
    },
    {
      icon: FEATURE_ICONS.TARGET,
      title: "Strategy aware",
      text: "Set your strategic north star—industry, audience, values—and Create adapts its exploration space to meet it. Need premium restraint for fintech? We lean into timeless grids and precise spacing. Launching a consumer app? Expect approachable forms, friendly motion, and colorways that pass accessibility while still popping in crowded feeds. Strategy stops being a slide and starts becoming a parameter.",
    },
    {
      icon: CONTENT_ICONS.GOLD_MEDAL,
      title: "Production‑ready",
      text: 'When you say "done," Create means it. Export crisp vectors, responsive logo sets, and brand tokens ready for design systems and registration workflows. Hand‑off packs include palette recommendations, spacing guidance, mis‑use examples, and real‑world previews—from app icons to signage—so decision‑makers can approve with confidence and teams can build without guessing.',
    },
    {
      icon: STATUS_ICONS.CHECK,
      title: "Built for brand teams",
      text: "Brand work is collaborative by nature. Organize explorations by project, comment inline, assign next steps, and track every iteration in an audit trail from first spark to final sign‑off. Bulk exports, CSV/PDF review packets, and integrations with your storage and design tools keep teams in flow—whether you're a solo founder or an enterprise studio shipping daily.",
    },
  ],
  testimonial: {
    text: "We generated over 200 logo concepts in minutes. The AI understood our brand vision perfectly and delivered designs that were both creative and legally sound.",
    author: "Michael Chen",
    title: "Founder, StartupLab",
    avatar:
      "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
  },
};

export default tadreamkCreateData;
